function ProjectedCashFlowsTable({ cashFlows }) {
    if (cashFlows.length === 0) {
        return null;
    }

    return (
        <table style={{ width: '100%' }}>
            <thead>
                <tr>
                    <th>Year</th>
                    <th>Future FCF</th>
                    <th>Discounted FCF</th>
                </tr>
            </thead>
            <tbody>
                {cashFlows.map((flow) => (
                    <tr key={flow.year}>
                        <td>{flow.year}</td>
                        <td>${Number(flow.futureFCF).toLocaleString()}</td>
                        <td>${Math.ceil(Number(flow.discountedFCF)).toLocaleString()}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default ProjectedCashFlowsTable;
